import React from 'react';
import { Select } from '@windmill/react-ui';
// import Select from 'react-select';
const SelectUser = ({ t,setSelecttedUser, name, label, users,selecttedUser }) => {
  // const options = users?.map((user) => ({
  //   value: user.id,
  //   label: user.name,
  // }));


  
  console.log('type state', typeof selecttedUser)
  console.log('rrrrrrr',selecttedUser)


  
  return (


<Select
  onChange={(e) => setSelecttedUser(e.target.value)}
  className="border h-8 text-xs focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
  value={selecttedUser}
>
  <option value="" defaultValue hidden>
    {t('User')}
  </option>
  {users?.map((user) => (
    <option key={user.id} value={user.id} selected={user.id===selecttedUser}>
      {user.name}
    </option>
  ))}
</Select>
  );
};

export default SelectUser;
